import { DialogType } from '@shared/dialogs/dialog-application/dialog-application.models'
import { ApplicationName } from '@performance/ui'
import { IMAGE_BASE_PATH } from '@shared/dialogs/dialog-application/dialog-application.constants'

export const getHeader = (type: DialogType, app: ApplicationName | string) => [
  {
    image: `${IMAGE_BASE_PATH}logo--${app}.svg`,
    class: 'mcp-dialog-application__header-name',
  },
  {
    image: `${IMAGE_BASE_PATH}platform--${app}.png`,
    class: 'mcp-dialog-application__header-platform',
  },
]
